import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as SiIcons from 'react-icons/si';

interface IconProps {
  icon: string;
  className?: string;
}

// A wrapper component for React Icons to solve TypeScript issues
export const Icon: React.FC<IconProps> = ({ icon, className }) => {
  // Determine which icon library to use based on prefix
  const lib = icon.startsWith('Fa') ? FaIcons : SiIcons;
  
  // Get the icon component
  const IconComponent = lib[icon as keyof typeof lib];
  
  // Render the icon or null if not found
  return IconComponent ? React.createElement(IconComponent, { className }) : null;
};

export default Icon;
